import { useState, useEffect } from 'react'
import { useStore, useSelector } from 'statux'
import { getCookie, setCookie } from '../../utils/cookies'

import Details from '../Details/Details'
import RichText from '../RichText/RichText'

export default function Alert (props = {
    className: null,
    details: null,
    dismissible: true,
    fluid: false,
    fluidCondensed: false,
    icon: false,
    iconClassName: null,
    modified: null,
    richText: null,
    role: null,
    style: null,
    type: null,
    userRoles: null
}) {
    const dismissible = !('dismissible' in props
        && !props.dismissible)

    const id = props.modified
        && `alert-${props.modified}`

    const isGlobalAlert = id
        && useSelector('alert')
        && id === `alert-${useSelector('alert.modified')}`

    const [active, setActive] = isGlobalAlert
        ? useStore('alert')
        : useState(true)

    const isChildren = props.children

    const isDetails = !isChildren
        && (props.details || {}).summary
        && props.details.text

    const isRichText = !isChildren
        && !isDetails
        && props.richText

    const isRender = isChildren
        || isDetails
        || isRichText

    useEffect(() => {
        if (isRender
                || (isGlobalAlert
                    && !getCookie(id)))
            return

        setActive(false)
    }, [props])

    if (!active
            || !isRender)
        return null

    const onCloseBtnClick = (e) => {
        if (isGlobalAlert)
            setCookie(id, 'true')

        setActive(false)
    }

    let icon = typeof props.icon === 'object'
        && typeof props.icon.type === 'function'
        && props.icon

    if (!icon) {
        let iconId = typeof props.icon === 'string'
            && props.icon.match(/^icon-/)
            && props.icon

        if (!iconId
                && props.icon
                && (!props.type
                    || props.type === 'info'))
            iconId = 'icon-info'

        if (!iconId
                && props.icon
                && props.type === 'success')
            iconId = 'icon-check-circle'

        if (!iconId
                && props.icon
                && props.type === 'error')
            iconId = 'icon-error'

        if (iconId)
            icon = (
                <svg
                    className={iconId}
                    width="18"
                    height="18"
                    aria-hidden="true"
                >
                    <use xlinkHref={`#${iconId}`} />
                </svg>
            )
    }

    return (
        <div
            id={id}
            className={`alert${
                props.type
                        && props.type !== 'Alert'
                    ? ` alert-${props.type}`
                    : ''}${
                isDetails
                    ? ' alert-details'
                    : ''} ${
                props.className || ''}`.trim()}
            role={props.role || 'alert'}
            style={props.style}
        >
            <div
                className={props.fluid
                        || props.fluidCondensed
                    ? `flex-grow ${props.fluidCondensed
                        ? 'pad-2-l pad-2-r pad-1-t pad-1-b'
                        : (isDetails
                            ? 'pad-3-l pad-3-r pad-t pad-b'
                            : 'pad-3')}`
                    : 'container pad-1-t pad-1-b'}
            >
                <div className="row-condensed flex-nowrap flex-justify-content-space-between">
                    {icon
                        && (
                            <div className="col-auto pad-0-r">
                                <div
                                    className={`alert-icon${
                                        props.iconClassName
                                            ? ` ${props.iconClassName}`
                                            : ''}`}
                                >
                                    {icon}
                                </div>
                            </div>
                        )}
                    <div className="col body-3">
                        {isChildren
                            && props.children}
                        {isDetails
                            && (
                                <Details>
                                    <summary>
                                        <span
                                            className="display-inline-flex flex-align-items-center"
                                        >
                                            <span>{props.details.summary}</span>
                                        </span>
                                    </summary>
                                    <RichText html={props.details.text} />
                                </Details>)}
                        {isRichText
                            && <RichText html={props.richText} />}
                    </div>
                    {dismissible
                        && (
                            <div className="col-auto display-inline-flex flex-align-items-center">
                                <button
                                    className="btn-unstyled alert-close-btn"
                                    aria-label="Close alert"
                                    onClick={onCloseBtnClick}
                                >
                                    <svg
                                        className="icon-close"
                                        width="18"
                                        height="18"
                                    >
                                        <use xlinkHref="#icon-close" />
                                    </svg>
                                </button>
                            </div>)}
                </div>
            </div>
        </div>
    )
}
